import EmptyState from "../components/shared/EmptyState";
import ErrorState from "../components/shared/ErrorState";
import FinalResultsTable from "../components/results/FinalResultsTable";
import LoadingState from "../components/shared/LoadingState";
import { Container } from "@mui/material";
import { hasVisibleFinalResults, isCompetitionVisibleInResults } from "../utils/resultPublicationUtils";
import { useCategoryContext } from "../contexts/CategoryContext";
import { useNavigationHelper } from "../hooks/useNavigationHelper";

export default function FinalResultsView() {
  const { category, competition, loading, error } = useCategoryContext();
  const { goBack } = useNavigationHelper();

  if (loading) {
    return (
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <LoadingState message="Ładowanie wyników końcowych..." />
      </Container>
    );
  }

  if (error) {
    return (
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <ErrorState message={error} />
      </Container>
    );
  }

  if (
    !competition ||
    !category ||
    !category.finalResults ||
    !isCompetitionVisibleInResults(competition) ||
    !hasVisibleFinalResults(category)
  ) {
    return (
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <ErrorState message="Dla tej kategorii nie opublikowano wyników" />
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 2 }}>
      <FinalResultsTable
        competitionName={competition.fullName || competition.name}
        categoryName={category.fullName || category.name}
        finalResults={category.finalResults}
        onBack={goBack}
      />
    </Container>
  );
}
